setTimeout(function() {
  var subtitleBlock = document.querySelector(
    '#shopify-section-template--30370216935763__section_XVCgxb .text-block--AQThjWXNERHRjN0cwb__text_aVaq6f'
  );
  if (subtitleBlock) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.7 });
    observer.observe(subtitleBlock);
  }

  var fairyBlock = document.querySelector(
    '#shopify-section-template--30370216935763__section_XVCgxb .image-block--ASHRoWFU2Z0xOOVhkO__image_Wt9rPH'
  );
  if (fairyBlock) {
    var fairyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fairyObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.7 });
    fairyObserver.observe(fairyBlock);
  }
}, 1000);
